(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/process-data/handle-pay-response.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/process-data/handle-pay-response.js');

'use strict';

const statuses = {
  FAILURE: 'FAILURE',
  INCOMPLETE: 'INCOMPLETE',
  SUCCESS: 'SUCCESS'
};
const badDrawNumberErrorCodes = [8104,
8105,
8146,
104,
105,
146 
];
function handlePayResponse(_ref) {
  let {
    next,
    cancel,
    regWagerResults,
    wagers,
    successfulWagers = [],
    failedWagers = []
  } = _ref;
  const incompleteWagers = [];
  for (let i = 0, len = regWagerResults.length; i < len; i++) {
    const {
      status,
      regWagerResult,
      tpError
    } = regWagerResults[i];
    const wager = wagers[wagers.length - (regWagerResults.length - i)];
    if (status === statuses.FAILURE) {
      if (i === 0 && regWagerResults.length === wagers.length) {
        const errorCode = typeof tpError.errCode === 'string' ? parseInt(tpError.errCode.replace(/\s/g, ''), 10) : tpError.errCode;
        if (badDrawNumberErrorCodes.includes(errorCode)) {
          return next({
            closedWager: wager
          });
        }
      }
      failedWagers.push({
        tpError,
        wager
      });
    }
    if (status === statuses.INCOMPLETE) {
      incompleteWagers.push(wager);
    }
    if (status === statuses.SUCCESS) {
      successfulWagers.push({
        wagerClientSerial: regWagerResult.wagerClientSerial,
        wagerAmounts: regWagerResult.wagerAmounts,
        wager
      });
    }
  }
  if (!successfulWagers.length && !incompleteWagers.length) {
    var _failedWagers$;
    return svs.tur.apierrors.showErrorMessage({
      response: (_failedWagers$ = failedWagers[0]) === null || _failedWagers$ === void 0 || (_failedWagers$ = _failedWagers$.tpError) === null || _failedWagers$ === void 0 ? void 0 : _failedWagers$.errCode,
      onConfirm: cancel
    });
  }
  if (incompleteWagers.length) {
    return next({
      incompleteWagers,
      successfulWagers,
      failedWagers
    });
  }
  next({
    successfulWagers,
    failedWagers
  });
}
svs.numbergames.pay_numbergames.handlePayResponse = handlePayResponse;

 })(window);